import { useState } from 'react';

const useProgressBar = () => {
  const [progress, setProgress] = useState(0);

  const updateProgress = event => {
    const testEvent = event.actualProgress + event.loaded;
    const newProgress = (testEvent / event.total) * 100;
    setProgress(newProgress);
  };

  return { progress, updateProgress };
};

export default useProgressBar;
